import { signIn } from "next-auth/react";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useUser } from "./use-user";
import { authTarget } from "../types/constants";
import { siteConfig } from "configuration/config";

export const signupStatusKey = "signup-status";
export type SignupStatus = {
  redirect?: "organization" | "user";
};

export function useAuthB2CRedirect() {
  const [isRedirecting, setIsRedirecting] = useState(false);
  const { sessionUser, subscriptionIsActive, userDidLoad } = useUser(false);
  const router = useRouter();
  const isLoading = !userDidLoad || router.isFallback || isRedirecting;

  useEffect(() => {
    if (isLoading || isRedirecting) {
      return;
    }

    if (sessionUser && !subscriptionIsActive) {
      setIsRedirecting(true);
      router.push("/billing");
      return;
    }

    if (subscriptionIsActive) {
      setIsRedirecting(true);
      router.push("/app");
      return;
    }

    if (router.query.forwardSignup) {
      setIsRedirecting(true);
      signIn(authTarget, undefined, { screen_hint: "signup" });
      return;
    }

    if (siteConfig.authSignInPath) {
      setIsRedirecting(true);
      window.location.href = siteConfig.authSignInPath;
      return;
    }
  }, [router, subscriptionIsActive, sessionUser, isLoading, isRedirecting]);

  return { isLoading };
}
